import { render, staticRenderFns } from "./DetailBasicInfo.vue?vue&type=template&id=25ea448a&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./DetailBasicInfo.vue?vue&type=script&lang=js"
export * from "./DetailBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailBasicInfo.vue?vue&type=style&index=0&id=25ea448a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea448a",
  null
  
)

export default component.exports